import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import Chip from 'tio-reimagined/components/chip';
import { htmlSafe } from '@ember/template';
import type TasProgramTemplate from 'tio-data/models/tas-program-template';

export interface BenefitCardSignature {
  Args: {
    template: TasProgramTemplate;
    isEnrolled?: boolean;
  };
  Element: HTMLDivElement;
}

export default class BenefitCard extends Component<BenefitCardSignature> {
  get isDirectPayProgram() {
    return this.args.template.isDirectPayProgram;
  }

  <template>
    <div
      class="bg-white border border-gray-300/50 rounded-lg p-4 flex flex-col gap-6 hover:shadow-md transition-shadow"
      ...attributes
    >
      {{! Chips area - ENROLLED and COURSECA$H chips }}
      <div class="flex justify-end gap-2 min-h-5">
        {{#if @isEnrolled}}
          <Chip @appearance="faded" @intent="success" @size="sm">
            {{t "tas.dashboard.chips.enrolled"}}
          </Chip>
        {{/if}}
        {{#if this.isDirectPayProgram}}
          <Chip @appearance="faded" @intent="primary" @size="sm">
            {{htmlSafe (t "common.tas.course_cash.default")}}
          </Chip>
        {{/if}}
      </div>

      {{! Content }}
      <div class="flex flex-col gap-1.5">
        <h3 class="font-semibold text-base text-gray-900">
          {{@template.programName}}
        </h3>
        {{#if @template.programDescription}}
          <p class="text-sm text-gray-500 line-clamp-2">
            {{@template.programDescription}}
          </p>
        {{/if}}
      </div>

      {{! Link }}
      <div>
        <LinkTo
          @route="authenticated.tas.getting-started"
          @model={{@template.id}}
          class="text-base font-medium text-gray-900 underline hover:text-ocean-600"
        >
          {{t "tas.dashboard.see_more"}}
        </LinkTo>
      </div>
    </div>
  </template>
}
